export default __webpack_public_path__ + "static/Real-Estate-idengager-2888c481b9d494167289cdaead1ed94e.svg";